import { runDemo } from "../shared/demoRunner";
import { createParticlesScene } from "./scene";

runDemo({
    createScene: createParticlesScene,
});
